import z from "zod";

const phoneNumberSchema = z
    .string()
    .regex(/^(\+420 ?)?[1-9]\d{2} ?\d{3} ?\d{3}$/, {
        message: "Telefonní číslo musí být ve formátu '+420 123 456 789' nebo '123 456 789'"
    });

export { phoneNumberSchema };
